import React from 'react';
import DynamicTextField from './DynamicTextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import SaveIcon from '@material-ui/icons/Save';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import * as authHelpers from '../authentication/authHelpers';
import * as routeHelpers from '../authentication/routeHelpers';
import { actionCreators as authActions } from '../redux/actions/authActions';
import { Typography } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { isValidPhoneNumber } from 'react-phone-number-input'
import Container from "@material-ui/core/Container";

const ResetUnlockCode = (props) => {
	const history = useHistory();
	const ecrId = new URLSearchParams(history.location.search).get('ecrId');
	
	const notEmptyFieldValidation = (value) => {
		return value?.toString() ? '' : 'Field can not be empty'; 
	};

	const emailValidation = (email) => {
		// Regex taken from - https://emailregex.com/
        // Should be RFC 5322 Standard
		var emailValidationRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		if (emailValidationRegex.test(email)) {
			return null;
		}
		const isEmpty = notEmptyFieldValidation(email);
		return isEmpty ? isEmpty : 'Please enter a valid email';
	};

	const digitValidation = (digit) => {
		const isEmpty = notEmptyFieldValidation(digit);
		const isDigit = /^\d+$/.test(digit);

		return isEmpty ? isEmpty : isDigit ? '' : 'Please Insert a valid number';
	};

	const phoneNumberValidation = (phoneNumber) =>
	{
		if (isValidPhoneNumber(phoneNumber)){
			return null;
		}
		const isEmpty = notEmptyFieldValidation(phoneNumber);
		return isEmpty ? isEmpty : 'Please enter a valid phone number';
	}

	
	const initialFormState = {
		email: {
			IsMandatory: true,
			ItemFieldError: '',
			FieldCode: 'email',
			FieldName: 'Email',
			Value: '',
			Validate: emailValidation,
			HelpText: "This is the email you had provided to us."

		},
		mobileNumber: {
			IsMandatory: true,
			ItemFieldError: '',
			FieldCode: 'mobileNumber',
			FieldName: 'Mobile Number',
			Value: '',
			Validate: phoneNumberValidation,
			HelpText: "This is the phone number you had provided to us. \n Example: +35679485588"
		},
		ecrId: {
			IsMandatory: true,
			ItemFieldError: '',
			FieldCode: 'ecrId',
			FieldName: 'Entity Change Request ID',
			Value: ecrId ,
			IsReadonly: !!ecrId,
			Validate: digitValidation
		},
	};

	const dialogConfirmResetUnlockCodeAction = () => {
		setShowDialog(false);
	};
	const dialogRedirectToLoginAction = () => {
		authHelpers.clearSession();
		window.location = routeHelpers.buildRoute(`/login`);
	};

	const dialogConfirmResetUnlockCodeHeader =
		'No user was found with the email provided.';
	const dialogConfirmResetUnlockCodeText =
		'Would you like to receive a new invitation?';

	const dialogRedirectToLoginHeader = 'Success';
	const dialogRedirectToLoginText =
		'You should have received an e-mail with the instructions to re-register. Please follow the instructions found there.';

	const [errorLog, setErrorLog] = React.useState('');
	const [resetUnlockCodeForm, setResetUnlockCodeForm] = React.useState(
		initialFormState
	);
	const [isFormSubmitted, setIsFormSubmitted] = React.useState(
		false
	);
	const [showDialog, setShowDialog] = React.useState(true);
	const [dialogHeader, setDialogHeader] = React.useState(
		dialogConfirmResetUnlockCodeHeader
	);
	const [dialogText, setDialogText] = React.useState(
		dialogConfirmResetUnlockCodeText
	);
	const [hasCancelOption, setHasCancelOption] = React.useState(true);

	const dialogConfirmAction = () => {
		if (dialogHeader === dialogConfirmResetUnlockCodeHeader) {
			dialogConfirmResetUnlockCodeAction();
		} else {
			dialogRedirectToLoginAction();
		}
	};
	const dialogCancelAction = () => {
		if (dialogHeader === dialogConfirmResetUnlockCodeHeader) {
			dialogRedirectToLoginAction();
			setShowDialog(false);
		}
	};

	const handleTextFieldChange = (event) => {
		if (!event) return;
		setResetUnlockCodeForm({
			...resetUnlockCodeForm,
			[event.target.name]: {
				...resetUnlockCodeForm[event.target.name],
				Value: event.target.value,
				ItemFieldError: resetUnlockCodeForm[event.target.name].Validate(event.target.value)
			},
		});
	};

	const showRedirectToLoginDialog = () => {
		setDialogHeader(dialogRedirectToLoginHeader);
		setDialogText(dialogRedirectToLoginText);
		setHasCancelOption(false);
		setShowDialog(true);
	};

	const resetFormWithError = (error) => {
		setResetUnlockCodeForm({});
		setResetUnlockCodeForm(initialFormState);
		setErrorLog(error ?? 'Something went wrong');
	};

	const submitResetUnlockCode = async () => {
		setIsFormSubmitted(true);
		if(validateForm()) {
			const error = await props.resetUnlockCode(buildModelFromForm());
			if (!error) showRedirectToLoginDialog();
			else resetFormWithError(error.errorMessage);
		};
	};

	const buildModelFromForm = () => {
		return {
			AccountUniqueName: authHelpers.getAccountUniqueNameFromUrl(),
			EmailAddress: resetUnlockCodeForm.email.Value,
			MobileNumber: resetUnlockCodeForm.mobileNumber.Value,
			EcrId: parseInt(resetUnlockCodeForm.ecrId.Value, 10),
		};
	};

	const validateForm = () => {
		let isValid = true;
		Object.keys(resetUnlockCodeForm).forEach( field => {
			resetUnlockCodeForm[field].ItemFieldError = 
				resetUnlockCodeForm[field].Validate(resetUnlockCodeForm[field].Value)
			if(resetUnlockCodeForm[field].ItemFieldError) isValid = false;
		});
		return isValid;
	};

	return (
		<Container maxWidth="sm">
		<>
			{props.isLoading ? (
				<>
					<div className='menu-loader-message'>Reseting account...</div>
					<LinearProgress />
				</>
			) : (
				<>
					<p>Kindly enter the below details so we can try and determine your user details. If successful,an email will be sent to the email provided with instructions on how to reset your user.</p>
					<p>If you are unsure of what details you have provided us, kindly call for assistance.</p>
					<FormGroup autoComplete='off'>
						{Object.keys(resetUnlockCodeForm).map((key) => (
							<DynamicTextField
								required
								key={key}
								field={resetUnlockCodeForm[key]}
								eventHandle={handleTextFieldChange}
								fieldError={resetUnlockCodeForm[key].ItemFieldError}
								name={key}
							/>
						))}
					</FormGroup>
					<Typography
						style={{ marginBottom: 20 }}
						variant='body2'
						color='error'
					>
						{errorLog}
					</Typography>
					<Button
						onClick={submitResetUnlockCode}
						variant='contained'
						color='secondary'
						startIcon={<SaveIcon />}
						autoFocus
						disabled={!validateForm()}
					>
						Reset Unlock Code
					</Button>

					<Dialog open={showDialog}>
						<DialogTitle id='alert-dialog-title'>{dialogHeader}</DialogTitle>
						<DialogContent>
							<DialogContentText id='alert-dialog-description'>
								{dialogText}
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={dialogConfirmAction} color='primary' autoFocus>
								Confirm
							</Button>
							{hasCancelOption ? (
								<Button
									onClick={() => {
										dialogCancelAction();
									}}
									color='primary'
								>
									Cancel
								</Button>
							) : (
								<></>
							)}
						</DialogActions>
					</Dialog>
				</>
			)}
			</>
		</Container>
	);
};

export default connect(
	(state) => state.authentication,
	(dispatch) => bindActionCreators(authActions, dispatch)
)(ResetUnlockCode);
